import { Component, Inject, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AdminService } from '../../../../../services/admin.service';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import moment from 'moment';
import { OrderShuttleBusService } from '../../../../../services/ordershuttlebus.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-back-office24-ordershuttlebus-create',
  templateUrl: './back-office24-ordershuttlebus-create.component.html',
  styleUrl: './back-office24-ordershuttlebus-create.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})

export class BackOffice24OrderShuttlebusCreateComponent implements OnInit, OnDestroy {
  createOrderShuttleBusForm: UntypedFormGroup;
  componentDestroyed$: Subject<boolean> = new Subject();
  routeCode: string;
  startDate: string;
  startTime: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public routeType: string,
    private fb: UntypedFormBuilder,
    public snackBar: MatSnackBar,
    public adminService: AdminService,
    public orderShuttleBusService: OrderShuttleBusService,
    public datepipe: DatePipe,
    public dialog: MatDialog,
    private dialogRef: MatDialogRef<BackOffice24OrderShuttlebusCreateComponent>,
  ) { }

  ngOnInit(): void {

    if (this.routeType == 'DEPARTURE') {
      this.routeCode = 'ARLDEP';
    }

    if (this.routeType == 'ARRIVAL') {
      this.routeCode = 'ARLARR';
    }

    this.startDate = moment().format();
    this.startTime = moment().format('HH:mm');

    this.initCreateOrderShuttleBusForm();
  }


  initCreateOrderShuttleBusForm() {
    this.createOrderShuttleBusForm = this.fb.group({
      routeCode: [{ value: this.routeCode, disabled: true }],
      startDate: [this.startDate],
      startTime: [this.startTime],
    });
  }

  createOrderShuttleBus() {
    this.setDateFormats();
    this.orderShuttleBusService
      .createOrderShuttleBus(this.routeCode, this.startDate + ' ' + this.startTime)
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(orderShuttleBusVM => {
        this.snackBar.open('Ny bussrutt skapad', 'OK', {
          verticalPosition: 'top',
          duration: 2000
        });
        this.dialogRef.close(orderShuttleBusVM);
      },
        error => {
          this.snackBar.open(`Felkod: ${error.status}`, 'Doh!', {
            verticalPosition: 'top'
          });
        }
      );
  }

  setDateFormats() {
    this.startDate = this.datepipe.transform(this.createOrderShuttleBusForm.controls['startDate'].value, 'yyyy-MM-dd');
    this.startTime = this.createOrderShuttleBusForm.controls['startTime'].value;
  }

  ngOnDestroy() {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }
}
